import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

//Process sequence
import ProcessSequence from "../pages/ProcessSequence/index"
import ProcessMaster from "../pages/ProcessSequence/ProcessMaster"

//Process sequence
import BatchDetails from "../pages/Batch/Batch-Details"
import BagList from "../pages/Batch/Bag-List"
import BagDetails from "../pages/Batch/Bag-Details"
import ScanQR from "../pages/Dashboard/index"
import Reports from "../pages/Reports/Reports"
import DueToday from "../pages/DueToday/DueToday"
import Output from "../pages/Output/Harvest"


import AdminFarmMaster from "../Admin/FarmMaster/Farmmaster"
import AdminProcessSequence from "../Admin/ProcessSequence/index"
import AdminProcessMaster from "../Admin/ProcessSequence/ProcessMaster"

//Process sequence
import AdminBatchDetails from "../Admin/Batch/Batch-Details"
import AdminBagList from "../Admin/Batch/Bag-List"
import AdminBagDetails from "../Admin/Batch/Bag-Details"
import AdminScanQR from "../Admin/Dashboard/index"
import AdminReports from "../Admin/Reports/Reports"
import AdminDueToday from "../Admin/DueToday/DueToday"
import AdminOutput from "../Admin/Output/Harvest"




const farmRoutes = [
  { path: "/profile", component: <UserProfile /> },

  { path: "/process-sequence", component: <ProcessSequence /> },
  { path: "/process-master", component: <ProcessMaster /> },

  { path: "/batch-details", component: <BatchDetails /> },
  { path: "/bag-list", component: <BagList /> },
  { path: "/bag-details", component: <BagDetails /> },

  { path: "/scan-qr-code", component: <ScanQR /> },
  { path: "/reports", component: <Reports /> },
  { path: "/due-today", component: <DueToday /> },
  { path: "/output", component: <Output /> },

  { path: "/", component: <Navigate to="/scan-qr-code" /> }
];


const adminRoutes = [
  { path: "/admin/farm-master", component: <AdminFarmMaster /> },
  { path: "/admin/process-sequence", component: <AdminProcessSequence /> },
  { path: "/admin/process-master", component: <AdminProcessMaster /> },

  { path: "/admin/batch-details", component: <AdminBatchDetails /> },
  { path: "/admin/bag-list", component: <AdminBagList /> },
  { path: "/admin/bag-details", component: <AdminBagDetails /> },

  { path: "/admin/scan-qr-code", component: <AdminScanQR /> },
  { path: "/admin/reports", component: <AdminReports /> },
  { path: "/admin/due-today", component: <AdminDueToday /> },
  { path: "/admin/output", component: <AdminOutput /> },

  { path: "/", component: <Navigate to="/admin/scan-qr-code" /> }
];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },



  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]


export { adminRoutes, farmRoutes, authRoutes };
